var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-steps',{staticClass:"style-step",attrs:{"current":_vm.current - 0,"size":"small","status":_vm.status}},_vm._l((_vm.currentList),function(i){return _c('a-step',{key:i.name,attrs:{"title":i.name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }